$(function () {
  $('.php-form textarea').on('input', function () {
    $(this).css('height', 'auto') // Reset height
    $(this).css('height', this.scrollHeight + 1 + 'px') // Set height based on scrollHeight
  })

  $('#contact-form')
    .find('input, textarea, button')
    .each(function () {
      var $this = $(this)

      function removeValidationMessage() {
        $this.parent().find('.form-validation-message').remove()
      }

      $this.change(removeValidationMessage)
      $this.keyup(removeValidationMessage)
    })
  $('#contact-form').submit(function (event) {
    event.preventDefault()

    var $form = $(this)
    var $submit = $form.find('button[type="submit"]')
    $form.find('.form-validation-message').remove()

    $submit.attr('disabled', 'disabled')
    $submit.after(
      '<span class="form-validation-message form-validation-info-message">' +
        settings.translation.sendingMail +
        '</span>',
    )
    let data = new FormData(this)
    fetch(settings.siteAddress + '/helpers/contact/contact.php', {
      method: 'post',
      body: new URLSearchParams(data).toString(),
      headers: {
        'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
      },
      cache: 'no-store',
      credentials: 'include',
    })
      .then(function (response) {
        $form.find('.form-validation-message').remove()
        return response.text()
      })
      .then(function (response) {
        response = JSON.parse(response)

        if (response.result === 'error') {
          if (response.message) {
            $submit.after(
              '<span class="form-validation-message form-validation-error-message">' +
                response.message +
                '</span>',
            )
          }
          if (response.fields) {
            for (const [field, message] of Object.entries(response.fields)) {
              $('#contact-form')
                .find('#' + field + ', label[for=' + field.replace(/\./g, '_') + ']')
                .each(function () {
                  var $this = $(this)
                  $this.after(
                    '<span class="form-validation-message form-validation-error-message">' +
                      message +
                      '</span>',
                  )
                })
            }
          }

          return
        }

        $('#contact-form')
          .find('input')
          .not('[type=checkbox], :button, :submit, :reset, :hidden')
          .attr('value', '')
          .val('')
        $('#contact-form input[type=checkbox]').prop('checked', false)

        $submit.after(
          '<span class="form-validation-message form-validation-success-message">' +
            settings.translation.mailSent +
            '</span>',
        )
        setTimeout(function () {
          $form.find('.form-validation-message').remove()
        }, 5000)

        location.href = $form.attr('data-success-redirect')
      })
      .catch(function (error) {
        console.error(error)
        $submit.after(
          '<span class="form-validation-message form-validation-error-message">' +
            settings.translation.genericError +
            '</span>',
        )
      })
      .finally(function () {
        $submit.removeAttr('disabled')
      })
    return false
  })
})
